import * as firebase from "firebase/app";
import "firebase/firestore";

//get queries
export const getDistribucionMedleysQEURY = async (ciclo) => {
    const response = await firebase.firestore().collection("ciclos").doc(ciclo).collection("distribucion_medleys").get();
    const distribucionMedleysDatos = response.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return distribucionMedleysDatos;
}